export default {
  newDesign: true,
  parameters: {
    landing_id: "InfwdTC",
    segment: 4
  },
  downtimeUrl: "https://www.kodland.org/id",
  title: "Kursus animasi dan desain grafis GRATIS untuk anak-anak dan remaja | Kodland",
  startPage: {
    footer: true,
    title:
      "Jawab 5 pertanyaan dan ikuti sesi interaktif ONLINE tentang PEMBUATAN ANIMASI secara GRATIS!",
    subtitle:
      "Anak Anda akan berkembang dalam bidang kreativitas digital, animasi, ilustrasi, pemodelan 3D, dan desain.",
    button: "Mulai Sekarang!",
    backgroundColor: "#fff",
    image: {
      url: "/welcome/indo_fwd_v2_desk.png",
      style: {
        height: "100%",
        "max-height": "100vh",
      },
    },
    imageMobile: {
      url: "/welcome/indo_fwd_v2_mob.png",
      style: {
        width: "100%",
      },
    },
  },
  stopPage: {
    image: "/welcome/quizV2/no-computer.png",
    title: "Terima kasih atas kepercayaan Anda pada platform pendidikan kami!",
    subtitle:
      "Sayangnya, tablet atau ponsel tidak sesuai untuk mengikuti pelajaran kami. Kami akan sangat senang melihat Anda di kelas berikutnya!",
  },
  quizRotateBySteps: {
    1: {
      question: "Berapa lama anak Anda biasanya menghabiskan waktu di depan gadget per hari?",
      answers: [
        "🥰 1 jam",
        "🙂 2-3 jam",
        "😔 lebih dari 4 jam",
      ],
    },
    2: {
      question: "Bagaimana Anda mendeskripsikan kepribadian anak Anda?",
      subtitle: "Jawaban ini akan membantu kami memilih metodologi pengajaran yang tepat.",
      answers: [
        "🥳 Aktif, banyak berkomunikasi",
        "😌 Pemalu",
        "🤫 Tenang, lebih suka sendirian",
        "❓Usulan saya (akan saya jelaskan di kelas)",
      ],
    },
    3: {
      question: "Seberapa besar motivasi anak Anda dalam belajar?",
      answers: [
        "🚀 Tinggi",
        "😕 Rendah",
        "🙂 Normal"
      ],
    },
    4: {
      title: "Berapa usia anak Anda?",
      type: "age",
      subtitle:
        "Kami akan memilih kursus yang paling sesuai dengan usia anak Anda.",
      button: "",
    },
    5: {
      question:
        "Untuk mengikuti kelas gratis ini, Anda perlu menggunakan komputer atau laptop (bukan HP) dengan koneksi internet stabil. Apakah Anda memiliki komputer/laptop di rumah?",
      answers: [
        "💻 Ya, kami memiliki komputer/laptop di rumah",
        {
          answer: "❌ Tidak, kami tidak memiliki komputer/laptop di rumah",
          stopAnswer: true,
        },
      ],
    },
    6: {
      title: "Tinggal satu langkah lagi 🎉",
      typeInfo: "congrats",
      subtitle:
        "Buka potensi kreatif anak Anda dalam coding dan kreativitas digital! 📅 Jadwalkan kelas",
      button: "📆 Pesan",
    },
    7: {
      title: "Daftar untuk kelas uji coba gratis",
      type: "one-page-contacts",
      subtitle: "Mari saling mengenal, cari tahu apa saja yang akan kita pelajari, dan seperti apa proses belajarnya nanti.",
      button: "Lanjutkan 🔥",
    },
    8: {
      title: "",
      type: "timeslot",
      subtitle: "",
      button: "",
    },
    9: {
      title: "Tinjau detail berikut untuk menyelesaikan pendaftaran ✨",
      typeInfo: "pc-laptop",
      subtitle:
        "Harap diperhatikan bahwa Anda akan membutuhkan komputer atau laptop yang berfungsi untuk pelajaran, dan Anda harus menemani anak Anda selama kelas berlangsung. Mohon diingat bahwa pelajaran ini bersifat individual dan personal.",
      button: "Selanjutnya bagaimana?",
    },
    10: {
      title: "Sebelum kelas uji coba, periksa email dan WhatsApp Anda 📞",
      typeInfo: "whatsapp",
      subtitle:
        "Kami akan mengirimkan pengingat 24 jam sebelum kelas dimulai dan meminta Anda untuk mengonfirmasikan kehadiran Anda 2 jam sebelum kelas dimulai. Sangat penting untuk tetap berkomunikasi agar kelas tidak dibatalkan.",
      button: "Selanjutnya bagaimana?",
    },
    11: {
      title: "Kelas akan diadakan di platform kami 💻",
      typeInfo: "classroom",
      subtitle:
        "Anda akan menerima tautan dan kode unik melalui WhatsApp dan email. Klik saja tautannya, dan Anda akan langsung diarahkan ke kelas. Tidak perlu aplikasi tambahan, tidak perlu mengunduh apa pun.",
      button: "Mengerti ✅",
    },
  },
};
